(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* Mobile menu */
  const mobileMenu = $('[data-mobile-menu]');
  $$('[data-menu-open]').forEach(b => b.addEventListener('click', () => { mobileMenu.hidden = false; document.body.classList.add('menu-open'); }));
  $$('[data-menu-close]').forEach(b => b.addEventListener('click', () => { mobileMenu.hidden = true; document.body.classList.remove('menu-open'); }));

  /* Search */
  const search = $('[data-search]');
  $$('[data-search-open]').forEach(b => b.addEventListener('click', e => { if (!search) return; e.preventDefault(); search.hidden = false; $('[data-search-input]').focus(); }));
  $$('[data-search-close]').forEach(b => b.addEventListener('click', () => { search.hidden = true; }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { if (search) search.hidden = true; if (mobileMenu) { mobileMenu.hidden = true; document.body.classList.remove('menu-open'); } } });

  /* Sticky header shadow */
  const header = $('[data-header]');
  if (header) window.addEventListener('scroll', () => header.classList.toggle('is-scrolled', window.scrollY > 10), { passive: true });

  /* Countdown */
  $$('[data-countdown]').forEach(el => {
    const target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) return;
    const pad = n => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => {
      const d = target - Date.now();
      const s = Math.floor(d / 1000);
      el.querySelector('[data-days]').textContent = pad(Math.floor(s / 86400));
      el.querySelector('[data-hours]').textContent = pad(Math.floor((s % 86400) / 3600));
      el.querySelector('[data-minutes]').textContent = pad(Math.floor((s % 3600) / 60));
      el.querySelector('[data-seconds]').textContent = pad(s % 60);
    };
    tick(); setInterval(tick, 1000);
  });

  /* Toast */
  const toast = $('#CartDrawerToast');
  const showToast = (msg) => { if (!toast) return; toast.textContent = msg; toast.classList.add('is-visible'); setTimeout(() => toast.classList.remove('is-visible'), 2800); };
  const updateCount = (n) => { const c = $('[data-cart-count]'); if (!c) return; c.textContent = n; c.hidden = n === 0; };

  /* Fly-to-cart dot */
  const flyToCart = (from) => {
    const cart = $('.header__cart'); if (!cart || !from) return;
    const a = from.getBoundingClientRect(), b = cart.getBoundingClientRect();
    const dot = document.createElement('span'); dot.className = 'fly-dot';
    dot.style.left = (a.left + a.width / 2 - 7) + 'px'; dot.style.top = (a.top + a.height / 2 - 7) + 'px';
    document.body.appendChild(dot);
    requestAnimationFrame(() => { dot.style.transform = `translate(${b.left + b.width / 2 - (a.left + a.width / 2)}px, ${b.top + b.height / 2 - (a.top + a.height / 2)}px) scale(.4)`; dot.style.opacity = '0'; });
    setTimeout(() => dot.remove(), 800);
  };

  /* AJAX add to cart (product page + cards) */
  const ajaxAdd = async (form, btn) => {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw await res.json();
      const cart = await (await fetch('/cart.js')).json();
      updateCount(cart.item_count);
      const c = $('[data-cart-count]'); if (c) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
      if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1800); flyToCart(btn); }
      showToast('Added to cart');
    } catch (err) {
      showToast((err && err.description) || 'Could not add to cart');
    } finally { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } }
  };
  document.addEventListener('submit', e => {
    const form = e.target;
    if (form.matches('[data-product-form]') || form.matches('.js-ajax-add')) { e.preventDefault(); ajaxAdd(form, form.querySelector('[type="submit"]')); }
  });

  /* Product page: variants, bundle, qty, gallery, sticky bar */
  const product = $('[data-product]');
  if (product) {
    const variantsEl = $('[data-variants]', product);
    const idInput = $('[data-variant-id]', product);
    const addBtn = $('[data-add-button]', product);
    const addText = $('[data-add-text]', product);
    const priceEl = $('[data-price-current]', product);
    const compareEl = $('[data-price-compare]', product);
    const saveEl = $('[data-price-save]', product);
    const saveBadge = $('[data-save-badge]', product);
    const stockEl = $('[data-stock]', product);
    const mainImg = $('#ProductMainImage');
    const qty = $('input[data-qty]', product);
    const stickyPrice = $('[data-sticky-price]', product);
    let price = +product.dataset.price, compare = +product.dataset.compare;
    const money = (cents) => {
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); }
    };
    const renderPrices = () => {
      if (priceEl) priceEl.textContent = money(price);
      const onSale = compare > price;
      if (compareEl) { compareEl.textContent = money(compare); compareEl.hidden = !onSale; }
      const pct = onSale ? Math.round((compare - price) * 100 / compare) : 0;
      if (saveEl) { saveEl.textContent = 'Save ' + pct + '%'; saveEl.hidden = !onSale; }
      if (saveBadge) { saveBadge.textContent = 'Save ' + pct + '%'; saveBadge.hidden = !onSale; }
      $$('[data-tier]', product).forEach(t => {
        const q = +t.dataset.qty, d = +t.dataset.discount;
        const tierPrice = Math.round(price * q * (100 - d) / 100), full = Math.max(compare, price) * q;
        const p = $('[data-tier-price]', t), c = $('[data-tier-compare]', t);
        if (p) p.textContent = money(tierPrice);
        if (c) { c.textContent = money(full); c.hidden = full <= tierPrice; }
      });
      const sel = $('[data-tier].is-selected', product);
      const total = sel ? Math.round(price * +sel.dataset.qty * (100 - +sel.dataset.discount) / 100) : price;
      const ap = $('[data-atc-price]', product), ac = $('[data-atc-compare]', product);
      if (ap) ap.textContent = money(total);
      if (ac) { const fullQ = Math.max(compare, price) * (sel ? +sel.dataset.qty : 1); ac.textContent = money(fullQ); ac.hidden = fullQ <= total; }
      if (stickyPrice) stickyPrice.textContent = money(sel ? Math.round(price * +sel.dataset.qty * (100 - +sel.dataset.discount) / 100) : price);
    };
    /* variants */
    if (variantsEl) {
      const variants = JSON.parse(variantsEl.textContent);
      const groups = $$('[data-option-index]', product);
      const valueOf = g => g.tagName === 'SELECT' ? g.value : (g.querySelector('input:checked') || {}).value;
      const update = () => {
        const chosen = groups.map(valueOf);
        groups.forEach((g, i) => { const lbl = g.closest('.product__option')?.querySelector('[data-option-value]'); if (lbl) lbl.textContent = chosen[i]; });
        const v = variants.find(v => chosen.every((val, i) => v['option' + (i + 1)] === val));
        if (!v) { addBtn.disabled = true; addText.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        addBtn.disabled = !v.available;
        addText.textContent = v.available ? addBtn.dataset.label || 'Add to cart' : 'Sold out';
        price = v.price; compare = v.compare_at_price || v.price;
        renderPrices();
        if (stockEl) stockEl.innerHTML = v.available ? stockEl.dataset.instock || stockEl.innerHTML : '<span class="dot dot--red"></span> Currently sold out';
        if (v.featured_image && mainImg) mainImg.src = v.featured_image.src;
        const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      };
      if (addBtn) addBtn.dataset.label = addText.textContent.trim();
      if (stockEl) stockEl.dataset.instock = stockEl.innerHTML;
      groups.forEach(g => g.addEventListener('change', update));
    }
    /* bundle tiers */
    $$('[data-tier]', product).forEach(t => t.querySelector('input').addEventListener('change', () => {
      $$('[data-tier]', product).forEach(x => x.classList.remove('is-selected'));
      t.classList.add('is-selected');
      if (qty) qty.value = t.dataset.qty;
      renderPrices();
    }));
    const selected = $('[data-tier].is-selected', product);
    if (selected && qty) qty.value = selected.dataset.qty;
    renderPrices();
    /* qty */
    $('[data-qty-minus]', product)?.addEventListener('click', () => { qty.value = Math.max(1, +qty.value - 1); });
    $('[data-qty-plus]', product)?.addEventListener('click', () => { qty.value = +qty.value + 1; });
    /* gallery */
    $$('[data-thumb]', product).forEach(t => t.addEventListener('click', () => {
      $$('[data-thumb]', product).forEach(x => x.classList.remove('is-active')); t.classList.add('is-active');
      if (mainImg) { mainImg.classList.add('is-switching'); const src = t.dataset.thumb; setTimeout(() => { mainImg.onload = () => mainImg.classList.remove('is-switching'); mainImg.src = src; }, 120); }
    }));
    /* sticky bar */
    const sticky = $('[data-sticky-atc]', product);
    if (sticky && addBtn) {
      const io = new IntersectionObserver(([e]) => { sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0; });
      io.observe(addBtn);
      const sBtn = $('[data-sticky-add]', sticky);
      sBtn.addEventListener('click', () => addBtn.click());
      new MutationObserver(() => { sBtn.classList.toggle('is-loading', addBtn.classList.contains('is-loading')); sBtn.classList.toggle('is-added', addBtn.classList.contains('is-added')); }).observe(addBtn, { attributes: true, attributeFilter: ['class'] });
    }
  }
})();
